const bidIncrements = [
    {
        "currency": "NOK",
        "fromAmount": 2.0,
        "toAmount": 275.0,
        "incrementAmount": 25
    },
    {
        "currency": "NOK",
        "fromAmount": 300.0,
        "toAmount": 950.0,
        "incrementAmount": 50.0
    },
    {
        "currency": "NOK",
        "fromAmount": 1000.0,
        "toAmount": 1900.0,
        "incrementAmount": 100.0
    },
    {
        "currency": "NOK",
        "fromAmount": 2000.0,
        "toAmount": 4800.0,
        "incrementAmount": 200
    },
    {
        "currency": "NOK",
        "fromAmount": 5000.0,
        "toAmount": 9500.0,
        "incrementAmount": 500.0
    },
    {
        "currency": "NOK",
        "fromAmount": 10000.0,
        "toAmount": 19000.0,
        "incrementAmount": 1000.0
    },
    {
        "currency": "NOK",
        "fromAmount": 20000.0,
        "toAmount": 48000.0,
        "incrementAmount": 2000.0
    },
    {
        "currency": "NOK",
        "fromAmount": 50000.0,
        "toAmount": 95000.0,
        "incrementAmount": 5000.0
    },
    {
        "currency": "NOK",
        "fromAmount": 100000.0,
        "toAmount": 490000.0,
        "incrementAmount": 10000.0
    },
    {
        "currency": "NOK",
        "fromAmount": 500000.0,
        "toAmount": 9950000.0,
        "incrementAmount": 50000.0
    }
];
export function getAvailableMaxBids(currentBidPrice, bidsCount, customersMaxBid, count = 16) {
    const availableMaxBids = new Array();
    let actualBid = Math.max(currentBidPrice, customersMaxBid !== null && customersMaxBid !== void 0 ? customersMaxBid : 1);
    if (bidsCount === 0) {
        availableMaxBids.push(currentBidPrice);
    }
    const lastIncrement = bidIncrements[bidIncrements.length - 1].incrementAmount;
    outerLoop: for (const { toAmount, incrementAmount } of bidIncrements) {
        while (availableMaxBids.length < count) {
            if (toAmount < actualBid)
                continue outerLoop;
            actualBid = actualBid - (actualBid % incrementAmount) + incrementAmount;
            availableMaxBids.push(actualBid);
        }
        if (availableMaxBids.length >= count)
            break;
    }
    while (availableMaxBids.length < count) {
        actualBid += lastIncrement;
        availableMaxBids.push(actualBid);
    }
    return availableMaxBids;
}
